/* assets/melange-review.js */
document.addEventListener('DOMContentLoaded', function () {
  var root = document.querySelector('[data-melange-review]');
  if (!root) return;

  var formCard = root.querySelector('#melange-review-form');
  var form = document.getElementById('MelangeReviewForm');
  var stickyCta = root.querySelector('.melange-review__sticky-cta');
  var faqButtons = root.querySelectorAll('[data-faq-button]');
  var commentField = root.querySelector('[data-comment-field]');
  var charCount = root.querySelector('[data-char-count]');
  var appsScriptUrl = (root.getAttribute('data-apps-script-url') || '').trim();
  var submitInProgress = false;

  faqButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      var item = button.closest('[data-faq-item]');
      if (!item) return;
      var expanded = button.getAttribute('aria-expanded') === 'true';
      item.classList.toggle('is-open', !expanded);
      button.setAttribute('aria-expanded', String(!expanded));
    });
  });

  if (commentField && charCount) {
    var updateCount = function () {
      charCount.textContent = String(commentField.value.length);
    };
    commentField.addEventListener('input', updateCount);
    updateCount();
  }

  root.querySelectorAll('[data-scroll-to-form]').forEach(function (trigger) {
    trigger.addEventListener('click', function (event) {
      if (!formCard) return;
      event.preventDefault();
      formCard.scrollIntoView({ behavior: 'smooth', block: 'start' });
      var firstField = formCard.querySelector('input:not([type="hidden"]), select, textarea, button');
      if (firstField) {
        window.setTimeout(function () {
          firstField.focus({ preventScroll: true });
        }, 320);
      }
    });
  });

  if (stickyCta && formCard && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyCta.style.opacity = entry.isIntersecting ? '0' : '1';
        stickyCta.style.pointerEvents = entry.isIntersecting ? 'none' : 'auto';
      });
    }, { threshold: 0.2 });
    observer.observe(formCard);
  }

  if (!form) return;

  var getFieldWrap = function (field) {
    return field.closest('[data-field-wrap]') || field.parentElement;
  };

  var setInvalidState = function (field, isInvalid) {
    var wrap = getFieldWrap(field);
    if (!wrap) return;
    wrap.classList.toggle('is-invalid', isInvalid);
  };

  var validateField = function (field) {
    if (field.type === 'checkbox') {
      return field.checked;
    }

    if (field.type === 'radio') {
      return Array.prototype.some.call(form.querySelectorAll('input[name="' + field.name + '"]'), function (radio) {
        return radio.checked;
      });
    }

    return field.value.trim() !== '';
  };

  var canMirrorToAppsScript = function () {
    return appsScriptUrl && appsScriptUrl.indexOf('REPLACE_ME') === -1;
  };

  var mirrorToAppsScript = function () {
    if (!canMirrorToAppsScript()) {
      return Promise.resolve(false);
    }

    var payload = new FormData(form);
    payload.set('submitted_at_utc', new Date().toISOString());
    payload.set('page_url', window.location.href);
    payload.set('page_title', document.title || '');

    if (navigator.sendBeacon) {
      try {
        var beaconSent = navigator.sendBeacon(appsScriptUrl, payload);
        if (beaconSent) {
          return Promise.resolve(true);
        }
      } catch (error) {
        /* noop */
      }
    }

    return fetch(appsScriptUrl, {
      method: 'POST',
      mode: 'no-cors',
      body: payload,
      keepalive: true,
      credentials: 'omit'
    }).then(function () {
      return true;
    }).catch(function () {
      return false;
    });
  };

  form.querySelectorAll('[data-required-field]').forEach(function (field) {
    var eventName = field.type === 'radio' || field.tagName === 'SELECT' ? 'change' : 'input';
    field.addEventListener(eventName, function () {
      setInvalidState(field, !validateField(field));
    });
  });

  form.addEventListener('submit', function (event) {
    var requiredFields = form.querySelectorAll('[data-required-field]');
    var firstInvalid = null;
    var validatedRadioNames = {};

    requiredFields.forEach(function (field) {
      if (field.type === 'radio') {
        if (validatedRadioNames[field.name]) return;
        validatedRadioNames[field.name] = true;
      }

      var isValid = validateField(field);
      setInvalidState(field, !isValid);

      if (!isValid && !firstInvalid) {
        firstInvalid = field;
      }
    });

    if (firstInvalid) {
      event.preventDefault();
      var targetWrap = getFieldWrap(firstInvalid);
      if (targetWrap && typeof targetWrap.scrollIntoView === 'function') {
        targetWrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      firstInvalid.focus();
      return;
    }

    var timestampField = form.querySelector('input[name="contact[送信時刻UTC]"]');
    if (timestampField) {
      timestampField.value = new Date().toISOString();
    }

    if (!canMirrorToAppsScript() || submitInProgress) {
      return;
    }

    event.preventDefault();
    submitInProgress = true;

    var submitButton = form.querySelector('.melange-review__submit');
    if (submitButton) {
      submitButton.disabled = true;
    }

    Promise.race([
      mirrorToAppsScript(),
      new Promise(function (resolve) {
        window.setTimeout(function () {
          resolve(false);
        }, 1200);
      })
    ]).finally(function () {
      HTMLFormElement.prototype.submit.call(form);
    });
  });
});
